import { makeSx } from '@saas/lib/shared-utils'
import { palette } from '../../../utilities'

export default makeSx({
    alert: {
        width: 'fit-content',
        padding: '0.5rem',
        gap: '0.5rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        borderRadius: '0.5rem',
    },
    alertContentContainer: {
        flex: 1,
    },
    alertTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '0.5rem',
    },
    alertTitle: {
        fontSize: '0.875rem',
    },
    alertText: {
        fontSize: '0.75rem',
    },
    alertIcon: {
        width: '1.125rem',
        height: '1.125rem',
    },
    alertSecondaryIcon: {
        width: '0.75rem',
        height: '0.75rem',
        opacity: 0.5,
    },
    alertTooltip: {
        display: 'flex',
        minWidth: '17rem',
        maxWidth: '24.625rem',
        padding: '1rem',
        backgroundColor: palette.typography['900'],
        color: palette.typography['100'],
        fontWeight: 600,
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        letterSpacing: '0.17px',
        border: 'none',
    },
    alertTooltipArrow: {
        color: palette.typography['900'],
    },
    // WARNING VARIANT
    alertWarningContainer: {
        backgroundColor: palette.warning['100'],
    },
    alertWarning: {
        color: palette.warning['600'],
    },
    alertWarningIcon: {
        color: palette.warning['600'],
    },
    // INFO VARIANT
    alertInfoContainer: {
        backgroundColor: palette.transmission['200'],
    },
    alertInfo: {
        color: palette.transmission['600'],
    },
    alertInfoIcon: {
        color: palette.transmission['600'],
    },
})
